var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "warning_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#warning_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M3.425 20.5a.878.878 0 0 1-.772-.452.955.955 0 0 1-.128-.438.816.816 0 0 1 .127-.466l8.561-14.788A.896.896 0 0 1 12 3.904a.897.897 0 0 1 .787.452l8.56 14.788c.093.154.136.31.128.466a.954.954 0 0 1-.129.438.878.878 0 0 1-.771.452H3.425ZM4.45 19h15.1L12 6 4.45 19ZM12 17.808c.229 0 .42-.078.575-.232a.782.782 0 0 0 .233-.576.781.781 0 0 0-.232-.576.782.782 0 0 0-.576-.232.781.781 0 0 0-.575.232.781.781 0 0 0-.233.576c0 .229.078.42.232.576a.781.781 0 0 0 .576.232Zm0-2.616c.213 0 .391-.072.535-.215a.726.726 0 0 0 .215-.535v-3.5a.726.726 0 0 0-.216-.534.727.727 0 0 0-.534-.216.725.725 0 0 0-.535.216.726.726 0 0 0-.215.534v3.5c0 .213.072.39.216.535a.726.726 0 0 0 .534.215Z",
    fill: "currentColor"
  }))));
};
export default SvgWarning;